import React, { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { HooksActionCreators } from './partnersActions';
import BreadCrumbs from '../utils/BreadCrumbs';
import { PartnerForm } from './PartnerForm';

const inputs = [
    { name: 'name', label: 'Partner name', isFocused: true },
    { name: 'sublocation', label: 'Sublocation' },
    { name: 'city', label: 'City' },
    { name: 'country', label: 'Country' },
    { name: 'phoneNumber', label: 'Phone number' },
    { name: 'email', label: 'Email', type: 'email' },
];

export default function PartnerAddPage() {
    const dispatch = useDispatch();
    const createPartner = useMemo(() => HooksActionCreators.createPartner(dispatch), []);
    const handleSubmit = useCallback((formData) => {
        createPartner(formData).catch((e) => e);
    }, []);
    return (
        <>
            <BreadCrumbs path={`/partners/new`} />
            <h3>New Partner</h3>
            <PartnerForm fields={inputs} onSubmit={handleSubmit} />
        </>
    );
}
